import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { Job, MockJobService } from '../../services-mock/mock-job.service';

@Component({
  selector: 'app-job-card',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule],
  template: `
    <div class="job-card">
      <div class="job-image-container" [routerLink]="['/jobs', job.id]">
        <img [src]="job.imageUrl" [alt]="job.title" class="job-image" />
      </div>
      <div class="job-content" [routerLink]="['/jobs', job.id]">
        <h3 class="job-title">{{ job.title }}</h3>
        <div class="job-company">{{ job.company }}</div>
        <div class="job-location">
          <i class="pi pi-map-marker"></i>
          {{ job.location }}
        </div>
      </div>
      <div class="job-actions">
        <button
          type="button"
          class="like-button"
          [class.liked]="isLiked"
          (click)="toggleLike($event)"
          [attr.aria-label]="isLiked ? 'Unlike job' : 'Like job'"
        >
          <i class="pi" [ngClass]="isLiked ? 'pi-heart-fill' : 'pi-heart'"></i>
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .job-card {
        background-color: #ffffff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
      }

      .job-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }

      .job-image-container {
        width: 100%;
        height: 150px;
        overflow: hidden;
        background-color: #f5f5f5;
        cursor: pointer;
      }

      .job-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .job-content {
        padding: 1rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        cursor: pointer;
      }

      .job-title {
        font-size: 1rem;
        font-weight: 600;
        color: #000000;
        margin: 0 0 0.5rem 0;
        line-height: 1.3;
      }

      .job-company {
        font-size: 0.9rem;
        color: #666666;
        margin-bottom: 0.5rem;
      }

      .job-location {
        font-size: 0.85rem;
        color: #999999;
        display: flex;
        align-items: center;
        gap: 0.25rem;
        margin-top: auto;
      }

      .job-location i {
        font-size: 0.8rem;
      }

      .job-actions {
        padding: 0.5rem 1rem;
        display: flex;
        justify-content: flex-end;
        border-top: 1px solid #e5e5e5;
      }

      .like-button {
        background: transparent;
        border: none;
        color: #666666;
        cursor: pointer;
        padding: 0.5rem;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
      }

      .like-button:hover {
        background-color: #f5f5f5;
        color: #0066cc;
      }

      .like-button.liked {
        color: #e91e63;
      }

      .like-button.liked:hover {
        background-color: #fce4ec;
      }

      .like-button i {
        font-size: 1.1rem;
      }
    `,
  ],
})
export class JobCardComponent implements OnInit {
  @Input() job!: Job;
  @Output() likeChanged = new EventEmitter<void>();
  isLiked = false;

  constructor(private jobService: MockJobService) {}

  ngOnInit() {
    this.isLiked = this.jobService.isJobLiked(this.job.id);
  }

  toggleLike(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.isLiked) {
      this.jobService.unlikeJob(this.job.id).subscribe(() => {
        this.isLiked = false;
        this.likeChanged.emit();
      });
    } else {
      this.jobService.likeJob(this.job.id).subscribe(() => {
        this.isLiked = true;
        this.likeChanged.emit();
      });
    }
  }
}

